import { createFileRoute } from '@tanstack/react-router';
import { AGGREGATE_NAMES, USER_RESOLVERS } from 'cpool-constants';
import { schemaUserResolver_GetAdvisersByTeam } from 'cpool-tables/backend-resolvers';

import { ROUTE_ROLES } from '~/features/auth/constants/routeRoles';
import { authoriseUser } from '~/features/auth/utils/authoriseUser';
import { adviserListSearchSchema } from '~/features/userStructures/schemas/adviserListSearch.schema';
import { getQueryOptions } from '~/queryUtils/getQueryOptions';
import { useUserStore } from '~/store/userStore';

const advisersListQueryOptions = () => {
    const { user } = useUserStore.getState();
    return getQueryOptions({
        aggregateName: AGGREGATE_NAMES.USER,
        resolverName: USER_RESOLVERS.getAdvisersByTeam,
        schema: schemaUserResolver_GetAdvisersByTeam,
        searchParams: { teamLeaderId: user?.id },
    });
};

export const Route = createFileRoute('/_app/management/advisers/')({
    beforeLoad: ({ location }) => authoriseUser([...ROUTE_ROLES.ADVISERS], location),
    loader: async ({ context }) => context.queryClient.ensureQueryData(advisersListQueryOptions()),
    validateSearch: adviserListSearchSchema,
});
